import { Component, Inject, OnInit, ChangeDetectionStrategy } from '@angular/core';
import { CONSTANTS, Constants, LanguageService, User } from 'lib-trend-core';

@Component({
  selector: 'chat-root',
  template: `
    <alert></alert>
    <router-outlet></router-outlet>
  `,
  changeDetection: ChangeDetectionStrategy.Eager,
  standalone: false,
})
export class ChatAppComponent implements OnInit {

  constructor(
    private readonly languageService: LanguageService,
    @Inject(CONSTANTS) private readonly constants: Constants,
  ) { }

  ngOnInit(): void {
    // Stored choice → user preference → company default → pt-BR, before any page renders.
    let user: User | undefined;
    try {
      const raw = localStorage.getItem(this.constants['currentUser']);
      user = raw ? JSON.parse(raw)?.user : undefined;
    } catch {
      user = undefined;
    }
    this.languageService.initFromUser(user);
  }
}
